// Images
import bogotaDisabled from '../images/cities/Bogota-disabled.svg';
import bogotaActive from '../images/cities/Bogota-activate.svg';
import medellinActive from '../images/cities/Medellin-activate.svg';
import medellinDisabled from '../images/cities/Medellin-disabled.svg';
import caliActive from '../images/cities/Cali-activate.svg';
import caliDisabled from '../images/cities/Cali-disabled.svg';
import bquillaActive from '../images/cities/Barranquilla-activate.svg';
import bquillaDisabled from '../images/cities/Barranquilla-disabled.svg';

// Data
import DataCo from '../../configEnv/CO/countryConfig.json';
import DataMX from '../../configEnv/MX/countryConfig.json';

const configEnv = {
  CO: DataCo,
  MX: DataMX,
};

export const dataConfig = configEnv[process.env.GATSBY_COUNTRY];

// Phone
const phone = {
  CO: '573009110474',
  MX: '525590881457',
};
export const contactPhone = phone[process.env.GATSBY_COUNTRY];

// Pagination
export const limit = 32;
export const limitMobile = 16;
export const previousOffset = 64;
export const previousOffsetMobile = 32;
export const skeleton = new Array(limit).fill(0);
export const skeletonMobile = new Array(limitMobile).fill(0);

// Inventory class or type
export const external = 2;
export const externalExclusive = 5;

// Agent
export const valuesCardCities = [
  {
    cityName: 'bogota',
    cityLabel: 'Bogotá',
    idCity: 1,
    activeSlide: bogotaActive,
    disabledSlide: bogotaDisabled,
  },
  {
    cityName: 'medellin',
    cityLabel: 'Medellín',
    idCity: 2,
    activeSlide: medellinActive,
    disabledSlide: medellinDisabled,
  },
  {
    cityName: 'cali',
    cityLabel: 'Cali',
    idCity: 20,
    activeSlide: caliActive,
    disabledSlide: caliDisabled,
  },
  {
    cityName: 'barranquilla',
    cityLabel: 'Barranquilla',
    idCity: 27,
    activeSlide: bquillaActive,
    disabledSlide: bquillaDisabled,
  },
];
export const infoFormulary = [
  {
    name: 'interes',
    component: 'buttons',
    title: '¿Qué estás buscando?',
    options: [
      { text: 'Comprar para vivir', value: 'compra' },
      { text: 'Vivir en arriendo', value: 'arriendo' },
      { text: 'Comprar para arrendar', value: 'invertir' },
    ],
  },
  {
    name: 'presupuesto',
    component: 'buttons',
    title: '¿Cuál es tu presupuesto?',
    options: [
      { text: 'Menos de $100 millones', value: '50-100' },
      { text: 'De $100 a $150 millones', value: '100-150' },
      { text: 'De $150 a $200 millones', value: '150-200' },
      { text: 'De $200 a $250 millones', value: '200-250' },
      { text: 'De $250 a $300 millones', value: '250-300' },
      { text: 'Más de $300 millones', value: '300-350' },
    ],
  },
  {
    name: 'ciudad',
    component: 'select',
    title: '¿En qué lugar estás buscando vivienda?',
  },
  {
    name: 'habitaciones_deseadas',
    component: 'circles',
    title: '¿Con cuántas habitaciones estás buscando el inmueble?',
    options: [
      { text: '1', value: '1' },
      { text: '2', value: '2' },
      { text: '3', value: '3' },
      { text: '4', value: '4' },
    ],
  },
  {
    name: 'banos_deseados',
    component: 'circles',
    title: '¿Con cuántos baños estás buscando el inmueble?',
    options: [
      { text: '1', value: '1' },
      { text: '2', value: '2' },
      { text: '3', value: '3' },
      { text: '4', value: '4' },
    ],
  },
  {
    name: 'plazo_de_compra',
    component: 'buttons',
    title: '¿En cuánto tiempo esperas conseguir tu apartamento?',
    options: [
      { text: 'Lo mas pronto posible', value: 'este_mes' },
      { text: 'De 1 a 3 meses', value: '2_meses' },
      { text: 'De 4 a 6 meses', value: '3-6_meses' },
      { text: 'De 7 a 12 meses', value: '6-12_meses' },
      {
        text: 'Solo estoy buscando información',
        value: 'solo_estoy_mirando',
      },
    ],
  },
  {
    name: 'posee_subsidio',
    component: 'buttons',
    title: '¿Utilizarás un subsidio para la compra del inmueble?',
    options: [
      { text: 'Si', value: 'si' },
      { text: 'No', value: 'no' },
    ],
  },
];
export const zonesFormulary = [
  {
    label: 'Suba',
    value: 'suba',
  },
  {
    label: 'Tibabita',
    value: 'tibabita',
  },
  {
    label: 'Nueva Zelandia',
    value: 'nueva_zelandia',
  },
  {
    label: 'Orquídeas',
    value: 'orquideas',
  },
  {
    label: 'Pinar de Suba',
    value: 'pinar_de_suba',
  },
  {
    label: 'Niza',
    value: 'niza',
  },
  {
    label: 'Prado Veraniego',
    value: 'prado_veraniego',
  },
  {
    label: 'Cedritos',
    value: 'cedritos',
  },
  {
    label: 'Bella Suiza',
    value: 'bella_suiza',
  },
  {
    label: 'Usaquen',
    value: 'usaquen',
  },
  {
    label: 'Villas de Granada',
    value: 'villas_de_granada',
  },
  {
    label: 'Engativa',
    value: 'engativa',
  },
  {
    label: 'Morato',
    value: 'morato',
  },
  {
    label: 'Fontibon',
    value: 'fontibon',
  },
  {
    label: 'Kennedy',
    value: 'kennedy',
  },
  {
    label: 'Los Monjes',
    value: 'los_monjes',
  },
  {
    label: 'Modelia',
    value: 'modelia',
  },
  {
    label: 'Sauzalito',
    value: 'sauzalito',
  },
  {
    label: 'Ciudad Salitre',
    value: 'ciudad_salitre',
  },
  {
    label: 'Teusaquillo',
    value: 'teusaquillo',
  },
  {
    label: 'Chapinero',
    value: 'chapinero',
  },
  {
    label: 'Tintala',
    value: 'tintala',
  },
  {
    label: 'Villa Alsacia',
    value: 'villa_alsacia',
  },
  {
    label: 'Timiza',
    value: 'timiza',
  },
  {
    label: 'Carvajal',
    value: 'carvajal',
  },
  {
    label: 'Puente Aranda',
    value: 'puente_aranda',
  },
  {
    label: 'Santa Fe',
    value: 'santa_fe',
  },
  {
    label: 'Antonio Nariño',
    value: 'antonio_narino',
  },
  {
    label: 'Rafael Uribe Uribe',
    value: 'rafael_uribe_uribe',
  },
  {
    label: 'San Javier',
    value: 'san_javier',
  },
  {
    label: 'Usme',
    value: 'usme',
  },
  {
    label: 'Bosa',
    value: 'bosa',
  },
  {
    label: 'El Poblado',
    value: 'el_poblado',
  },
  {
    label: 'Tunjuelito',
    value: 'tunjuelito',
  },
  {
    label: 'Ciudad Bolivar',
    value: 'ciudad_bolivar',
  },
  {
    label: 'Los Martires',
    value: 'los_martires',
  },
  {
    label: 'Barrios Unidos',
    value: 'barrios_unidos',
  },
];
